import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Link from "@material-ui/core/Link";

import { maybePluralize } from "../helpers";
import accounting from "accounting";

const salesTaxRate = 0.0675;
const salesTaxPercentage = accounting.toFixed(salesTaxRate * 100, 2) + "%";

const styles = (theme) => ({
  textField: {},
  boxesRemoveWrapper: {
    textAlign: "right",
  },
  subheader: {
    fontSize: "1.5rem",
    color: theme.palette.secondary.main,
  },
  estimateListItemTextPrimary: {
    fontSize: "2rem",
  },
  estimateListItemText: {
    textAlign: "right",
  },
  discountListItemTextPrimary: {
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  discountListItemTextSecondary: {
    color: "#000F9F",
  },
  discountListItemText: {
    textAlign: "right",
  },
});

class JobInfo extends Component {
  render() {
    const { classes } = this.props;

    const boxesListItems = Object.keys(this.props.boxesFormValues).map(
      (boxKey) => {
        //This is all really horrible stuff
        // const boxId = boxKey.substr(3).toString();
        const boxQuantity = this.props.boxesFormValues[boxKey];

        if (boxQuantity) {
          //zero or empty string or null
          const boxName = this.props.boxes.find(
            (box) => "box" + box.id === boxKey
          ).name;
          const boxPrice = this.props.boxes.find(
            (box) => "box" + box.id === boxKey
          ).price;
          // const formattedBoxPrice = accounting.formatMoney(boxPrice);
          const totalBoxPrice = boxQuantity * boxPrice;
          const formattedTotalBoxPrice = accounting.formatMoney(totalBoxPrice);

          return (
            <ListItem key={boxKey}>
              <ListItemText
                primary={
                  formattedTotalBoxPrice + " (" + boxQuantity + ") " + boxName
                }
              />
            </ListItem>
          );
        } else {
          return null; //Return nothing
        }
      }
    );

    const subtotalBoxesPrice = Object.keys(this.props.boxesFormValues).reduce(
      (total, boxKey) => {
        const boxQuantity = this.props.boxesFormValues[boxKey];

        if (boxQuantity) {
          const boxPrice = this.props.boxes.find(
            (box) => "box" + box.id === boxKey
          ).price;
          const totalBoxPrice = boxQuantity * boxPrice;

          return totalBoxPrice + total;
        } else {
          return total; //Return total
        }
      },
      0
    );
    const boxesSalesTaxAmount = subtotalBoxesPrice * salesTaxRate;
    const totalBoxesPrice = subtotalBoxesPrice + boxesSalesTaxAmount;

    //TODO make below change with the daytype
    const totalEstimate =
      ((this.props.quote.hourlyRate * this.props.quote.estimatedDuration + 99) *
        (100 - this.props.quote.percent_off)) /
        100 -
      this.props.quote.amount_off;
    const percentOffAmount =
      ((this.props.quote.hourlyRate * this.props.quote.estimatedDuration + 99) *
        this.props.quote.percent_off) /
      100;

    return (
      <Grid item xs={12} md={12}>
        <List>
          <ListSubheader component={ListItem} disableSticky>
            <ListItemText
              primaryTypographyProps={{ className: classes.subheader }}
              primary="When"
            />
          </ListSubheader>
          <ListItem>
            <ListItemText
              primary={new moment(
                this.props.scheduleFormValues[0].startDate
              ).format("dddd, MMMM Do YYYY")}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                new moment(this.props.scheduleFormValues[0].startDate).format(
                  "h:mm a"
                ) +
                " to " +
                new moment(this.props.scheduleFormValues[0].startDate)
                  .add(this.props.quote.estimatedDuration, "hours")
                  .format("h:mm a") +
                " (" +
                this.props.quote.estimatedDuration +
                " estimated hours)"
              }
            />
          </ListItem>
        </List>

        <Divider />

        <List>
          <ListSubheader component={ListItem} disableSticky>
            <ListItemText
              primaryTypographyProps={{ className: classes.subheader }}
              primary="Address"
            />
          </ListSubheader>
          <ListItem>
            <ListItemText
              primary={"Starting from:"}
              secondary={
                this.props.originDestinationFormValues.originLocationId.label
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={"Moving to:"}
              secondary={
                this.props.originDestinationFormValues.destinationLocationId
                  .label
              }
            />
          </ListItem>
        </List>

        <Divider />

        <Grid
          item
          container
          alignItems="center"
          justify="space-between"
          xs={12}
        >
          <Grid item>
            <List>
              <ListSubheader component={ListItem} disableSticky>
                <ListItemText
                  primaryTypographyProps={{ className: classes.subheader }}
                  primary="Estimate"
                />
              </ListSubheader>
              <ListItem>
                <ListItemText
                  primary={this.props.quote.movers + " Moving Buddies"}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={maybePluralize(this.props.quote.trucks, "truck")}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    accounting.formatMoney(this.props.quote.hourlyRate) +
                    " hourly rate"
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    accounting.formatMoney(this.props.quote.flatFee) +
                    " flat fee"
                  }
                />
              </ListItem>
            </List>
          </Grid>
          <Grid item>
            <List>
              <ListItem>
                <ListItemText
                  className={classes.estimateListItemText}
                  primaryTypographyProps={{
                    className: classes.estimateListItemTextPrimary,
                  }}
                  primary={accounting.formatMoney(totalEstimate)}
                  secondary="Estimate"
                />
              </ListItem>
              {this.props.quote.percent_off !== 0 && (
                <ListItem>
                  <ListItemText
                    className={classes.discountListItemText}
                    primaryTypographyProps={{
                      className: classes.discountListItemTextPrimary,
                    }}
                    primary={`${this.props.quote.percent_off}% off (-$${percentOffAmount})`}
                    secondaryTypographyProps={{
                      className: classes.discountListItemTextSecondary,
                    }}
                    secondary={`Discount applied (${this.props.quote.promo_code})`}
                  />
                </ListItem>
              )}
              {this.props.quote.amount_off !== 0 && (
                <ListItem>
                  <ListItemText
                    className={classes.discountListItemText}
                    primaryTypographyProps={{
                      className: classes.discountListItemTextPrimary,
                    }}
                    primary={`$${this.props.quote.amount_off} off`}
                    secondaryTypographyProps={{
                      className: classes.discountListItemTextSecondary,
                    }}
                    secondary={`Discount applied (${this.props.quote.promo_code})`}
                  />
                </ListItem>
              )}
            </List>
          </Grid>
        </Grid>

        {this.props.boxesFormValues &&
          !(
            Object.entries(this.props.boxesFormValues).length === 0 &&
            this.props.boxesFormValues.constructor === Object
          ) && ( //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
            <Divider />
          )}

        {this.props.boxesFormValues &&
          !(
            Object.entries(this.props.boxesFormValues).length === 0 &&
            this.props.boxesFormValues.constructor === Object
          ) && ( //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
            <Grid
              item
              container
              alignItems="center"
              justify="space-between"
              xs={12}
            >
              <Grid item xs={12}>
                <List>
                  <ListSubheader component={ListItem} disableSticky>
                    <ListItemText
                      primaryTypographyProps={{ className: classes.subheader }}
                      primary="Boxes"
                    />
                    {this.props.handleRemoveBoxes && (
                      <ListItemSecondaryAction
                        className={classes.boxesRemoveWrapper}
                      >
                        <Link
                          onClick={this.props.handleRemoveBoxes}
                          color="secondary"
                          variant="body2"
                        >
                          Remove
                        </Link>
                      </ListItemSecondaryAction>
                    )}
                  </ListSubheader>
                </List>
              </Grid>
              <Grid item>
                <List>
                  {boxesListItems}
                  <ListItem key="boxSalesTax">
                    <ListItemText
                      primary={`Sales tax (${salesTaxPercentage})`}
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item>
                <List>
                  <ListItem>
                    <ListItemText
                      className={classes.estimateListItemText}
                      primaryTypographyProps={{
                        className: classes.estimateListItemTextPrimary,
                      }}
                      primary={accounting.formatMoney(totalBoxesPrice)}
                      secondary="Shipping included"
                    />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          )}
      </Grid>
    );
  }
}

JobInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  quote: PropTypes.object.isRequired,
  originDestinationFormValues: PropTypes.object.isRequired,
  handleRemoveBoxes: PropTypes.func,
  boxesFormValues: PropTypes.object, //May not exist if they skipped boxes
  boxes: PropTypes.array, //May not exist if they skipped boxes
  locationsFormValues: PropTypes.object.isRequired,
  scheduleFormValues: PropTypes.array.isRequired,
};

export default withStyles(styles)(JobInfo);
